import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-hero-card',
    templateUrl: './hero-card.component.html',
    styleUrls: ['./hero-card.component.scss'],
    standalone: true,
})
export class HeroCardComponent implements OnInit {
  @Input() header: string
  @Input() leadIn: string
  @Input() followupText: string
  constructor() {}

  ngOnInit(): void {}
}
